"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var manifest_1 = tslib_1.__importDefault(require("./manifest"));
var createReadOnlyValue = function (value) { return ({
    value: value,
    writable: false,
    enumerable: false,
    configurable: true
}); };
function createConsumerApi(manifests, exposureMap) {
    var api = {};
    Object.keys(exposureMap).forEach(function (key) {
        Object.defineProperty(api, key, createReadOnlyValue(exposureMap[key]));
    });
    Object.defineProperty(api, '@manifest', createReadOnlyValue(manifest_1["default"](manifests)));
    Object.defineProperty(window, '@Neos:HostPluginAPI', createReadOnlyValue(api));
}
exports["default"] = createConsumerApi;
//# sourceMappingURL=createConsumerApi.js.map